module.exports = __webpack_public_path__ + "img/search-glass.34d2ee0e.svg";